import React from 'react';
import { useDeviceDetection } from '../../hooks/useDeviceDetection';
import EditarReporteView from './EditarReporteView';
import EditarReporteMovilView from './EditarReporteMovilView';

/**
 * Vista automática que detecta el dispositivo y muestra
 * la versión apropiada del formulario de edición de reportes
 */
const EditarReporteAutoView: React.FC = () => {
  const { isMobile, isTablet } = useDeviceDetection();

  // Considerar tablets como móvil
  const esMobileOTablet = isMobile || isTablet;

  // Renderizar versión móvil o desktop según el dispositivo
  if (esMobileOTablet) {
    return <EditarReporteMovilView />;
  }

  return <EditarReporteView />;
};

export default EditarReporteAutoView;
